import { render, staticRenderFns } from "./magiczoom.vue?vue&type=template&id=01121a5e&"
import script from "./magiczoom.vue?vue&type=script&lang=js&"
export * from "./magiczoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/1088/82/Klettershop5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01121a5e')) {
      api.createRecord('01121a5e', component.options)
    } else {
      api.reload('01121a5e', component.options)
    }
    module.hot.accept("./magiczoom.vue?vue&type=template&id=01121a5e&", function () {
      api.rerender('01121a5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/klettershop/magiczoom.vue"
export default component.exports